import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      // Refresh auth session so protected routes resume cleanly
      try {
        await supabase.auth.refreshSession();
      } catch {
        // ignore — onAuthStateChange will reconcile
      }
    };
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
}
